import { VariantClassesProps } from '../../utils'
import { SwitcherColor, SwitcherSize, SwitcherVariant } from './Switcher.types'

// Main style getters
/** Base for switcher component */
export const getBaseClasses = (): string => {
    return 'relative shadow-modal peer after:absolute after:content-[""]  rtl:peer-checked:after:-translate-x-full after:transition-all'
}

/** Shape getters for switcher component */
export const getShapeClasses = (variant: SwitcherVariant): string => {
    const variantClasses: VariantClassesProps = {
        square: 'rounded-md after:rounded-sm',
        rounded: 'rounded-full after:rounded-full',
    }

    return variantClasses[variant] || variantClasses.rounded
}

/** Size getters for switcher component */
export const getSizeClasses = (size: SwitcherSize): string => {
    const sizeClasses: VariantClassesProps = {
        base: 'w-10 h-6 after:h-5 after:w-5 peer-checked:after:translate-x-[80%] after:start-[0.1rem] after:top-[0.15rem]',
        lg: 'w-12 h-6 after:h-5 after:w-5 peer-checked:after:translate-x-full after:start-[0.25rem] after:top-[0.12rem]',
    }
    return sizeClasses[size] || sizeClasses.base // Default size: base
}

/** Color getters for switcher component */
export const getColorClasses = (color: SwitcherColor): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'peer-checked:after:bg-background-primary after:bg-[hsl(var(--text-muted))]',
        secondary:
            'bg-[hsl(var(--background-input-dark))] after:bg-[hsl(var(--text-light-grey))] peer-checked:after:bg-white',
    }

    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Variant styles controller */
export const getVariantClasses = (variant: SwitcherVariant): string => {
    const variantClasses: VariantClassesProps = {
        square: getShapeClasses(variant),
        rounded: getShapeClasses(variant),
    }

    return variantClasses[variant] || variantClasses.rounded
}
